<ng-content></ng-content>

@if (label(); as labelText) {
  <span class="avatar__label">{{ labelText }}</span>
} @else if (icon(); as iconClass) {
  <span class="avatar__icon" [class]="iconClass"></span>
} @else if (displayImageSrc(); as imageSrc) {
  <img class="avatar__image" [attr.aria-label]="ariaLabel()" [src]="imageSrc" (error)="imageError()" alt="Avatar" />
}
